import { create } from "zustand";
import type { Country } from "@/components";

type ForgotPasswordPrefillStore = {
  phone: string;
  country: Country | null;
  setPrefill: (phone: string, country: Country) => void;
  clearPrefill: () => void;
};

// Estado somente em memória (não persiste em localStorage/cookies) para levar
// o celular digitado na tela de Auth até a tela de "esqueci minha senha".
export const useForgotPasswordPrefillStore = create<ForgotPasswordPrefillStore>(
  set => ({
    phone: "",
    country: null,
    setPrefill: (phone, country) => set({ phone, country }),
    clearPrefill: () => set({ phone: "", country: null }),
  })
);
